module.exports = __webpack_public_path__ + "static/media/lukasio.09ec191c.jpg";